import axios from 'axios';
import { history } from '../constants';
// import { store } from '../';

const API = axios.create({
  // baseURL: 'https://dandybooks-api.ifour-consultancy.net/api',
  // baseURL: 'http://192.168.0.33:5000/api',
  baseURL: 'https://api.b4tax.com.au/api',
});

//Api config for token passing in header while making api request
API.interceptors.request.use((req) => {
  if (localStorage.getItem('profile')) {
    const token = JSON.parse(localStorage.getItem('profile')!)?.token;
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// API.interceptors.response.use(
// 	(res) => {
// 		return res;
// 	},
// 	(error) => {
// 		console.log(error);

// 		error.response.status === 403 && history?.history('/dashboard');

// 		return error;
// 	}
// );
export default API;
